<div class="container login">
    <div class="row">
        <div class="col-md-12">
            <div class="box mt40 mb40 static">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="static-content">
                            <p><b>Medya ve İletişim Yönetimi:</b><br />
                                Canyaş İletişim<br />
                                Telefon: 0532 433 40 29<br />
                                Nilhan Altıntoprak - <a
                                    href="mailto:nilhanaltintoprak@canyas.com">nilhanaltintoprak@canyas.com</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>